module.exports = __webpack_public_path__ + "img/covid-cli.f7ded6e8.jpg";